import * as React from 'react'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import Link from '~/client/components/Link'

export default function FullPageMinimalLayout({
  children,
  ...props
}){
  React.useEffect(
    () => {
      document.body.style.overflow = 'hidden'
      return () => {
        document.body.style.overflow = null
      }
    }
  )
  return <Container sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '100vw',
    minHeight: '100vh',
  }}>
    {children}
    <Footer/>
  </Container>
}


function Footer(){
  return <Box
    sx={{
      flex: '2 2',
      display: 'flex',
      alignItems: 'flex-end',
      m: 2,
    }}
  >
    <Stack direction="row" spacing={2}>
      <Link variant="text" to="/terms">Terms</Link>
      <Link variant="text" to="/privacy">Privacy</Link>
      <Link variant="text" to="/security">Security</Link>
      <Link variant="text" to="/contact">Contact DataPal</Link>
    </Stack>

  </Box>
}
